function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "ic:round-refresh"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6995 12.6998C14.3758 11.0083 16.4107 9.715 18.6539 8.91536C20.897 8.11571 23.2912 7.83016 25.6595 8.07978C32.9995 8.81978 39.0395 14.7798 39.8595 22.1198C40.9595 31.8198 33.4595 39.9998 23.9995 39.9998C20.9793 39.9998 18.021 39.1428 15.4685 37.5285C12.9159 35.9141 10.8738 33.6086 9.57947 30.8798C8.93947 29.5398 9.89947 27.9998 11.3795 27.9998C12.1195 27.9998 12.8195 28.3998 13.1395 29.0598C14.3007 31.5578 16.2867 33.5797 18.7636 34.7854C21.2405 35.9911 24.0571 36.3069 26.7395 35.6798C31.1795 34.6998 34.7595 31.0798 35.6995 26.6398C36.0946 24.8843 36.09 23.0624 35.6861 21.309C35.2821 19.5555 34.4891 17.9153 33.3658 16.5096C32.2424 15.104 30.8174 13.9688 29.1961 13.1882C27.5749 12.4076 25.7989 12.0014 23.9995 11.9998C20.6795 11.9998 17.7195 13.3798 15.5595 15.5598L18.5795 18.5798C19.8395 19.8398 18.9595 21.9998 17.1795 21.9998H9.99947C8.89947 21.9998 7.99947 21.0998 7.99947 19.9998V12.8198C7.99947 11.0398 10.1595 10.1398 11.4195 11.3998L12.6995 12.6998Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.6b5d339cbf73268ba344b63e09c01d7c.svg";
export { ForwardRef as ReactComponent };